<template>
  <span>
    <v-card
      class="mx-auto"
      outlined
    >
      <v-list-item three-line>
        <v-list-item-content>
          <div class="title">Версия: 1.5.2</div>
          <div class="title">Сборка: 22.12.2021 00:00</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item three-line>
        <v-list-item-content>
          <div class="title">Версия: 1.3.3</div>
          <div class="title">Сборка: 20.05.2020 12:05</div>
          <v-list-item-title>Добавлен Личный Кабинет по Электросетям с возможностью:</v-list-item-title>
          <v-list-item-subtitle class="pl-8">Занести информацию по аккаунту</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Занести информацию поабоненту в разрезе</v-list-item-subtitle>
          <v-list-item-content>
            <v-list-item-subtitle class="pl-8">Физического лица</v-list-item-subtitle>
            <v-list-item-subtitle class="pl-8">Индивидуального предпринимателя</v-list-item-subtitle>
            <v-list-item-subtitle class="pl-8">Юридического лица</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-subtitle class="pl-8">Отправить заявление оператору Электрических сетей</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Получить помощь и поддержку от Электрических сетей</v-list-item-subtitle>
          <v-list-item-title>Со стороны оператора:</v-list-item-title>
          <v-list-item-subtitle class="pl-8">Добавлены «Шаблоны заявок»</v-list-item-subtitle>
          <v-list-item-content>
            <v-list-item-subtitle class="pl-8">Добавлены «Типы заявок»</v-list-item-subtitle>
            <v-list-item-subtitle class="pl-8">Добавлены «Требуемые файлы заявок»</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-subtitle class="pl-8">Добавлена форма «Поступившие заявки», они позволяют</v-list-item-subtitle>
          <v-list-item-content>
            <v-list-item-subtitle class="pl-8">Отрабатывать поступившие документы от абонента</v-list-item-subtitle>
            <v-list-item-subtitle class="pl-8">Отправлять документы абоненту</v-list-item-subtitle>
            <v-list-item-subtitle class="pl-8">Выносить решение о принятии или отказе по документам</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item-content>
      </v-list-item>
      <v-list-item three-line>
        <v-list-item-content>
          <div class="title">Версия: 1.2.3</div>
          <div class="title">Сборка: 19.05.2020 10:25</div>
          <v-list-item-title>Форма "Объектов":</v-list-item-title>
          <v-list-item-subtitle class="pl-8">Ускорение получение информации на всех вкладках</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Ускорение получение информации на всех вкладках</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Добавлены всплывающие подсказки для всех контролов</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">При присвоении ТУ добавлена информация о привязанных объектах</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">При присовоении ТУ добавлена возможность просмотреть весь список</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Убран столбец "Мониторинг"</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Убран столбец "Инфо"</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Исправлена ошибка при переключениях между объектами</v-list-item-subtitle>
          <v-list-item-title>Форма "Текущие показания":</v-list-item-title>
          <v-list-item-subtitle class="pl-8">Получение данных сделано асинхронным</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Последние показания сохраняются</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Добавлена возможность выбора необходимых для получения показаний</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Добавлены параметры измерения</v-list-item-subtitle>
          <v-list-item-title>Форма "Точки учёта":</v-list-item-title>
          <v-list-item-subtitle class="pl-8">Добавлена информация об отсутсвующх счётчиках</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Добавлена информация о привязанных объектах</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Добавлены всплывающие подсказки для всех контролов</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">На вкладке счётчиков добавлена информация о статусе счётчика</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">На вкладке счётчиков добавлена информация о "Коэф.трансформации тока"</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">На вкладке счётчиков доступность контролов меняется в зависимости от статуса счётчика</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">На вкладке счётчиков при снятии счётчика добавлено поле "Причина снятия счётчика"</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Полностью изменена форма добавления счётчика по точке учёта</v-list-item-subtitle>
          <v-list-item-title>Справочник "Модели счётчиков":</v-list-item-title>
          <v-list-item-subtitle class="pl-8">Полностью переработана</v-list-item-subtitle>
          <v-list-item-title>Отчёты:</v-list-item-title>
          <v-list-item-subtitle class="pl-8">Добавлен - "Профили мощности"</v-list-item-subtitle>
          <v-list-item-subtitle class="pl-8">Добавлен - "Показание счетчиков и потребление электрической энергии за период с учетом тарифных зон"</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </span>
</template>

<script>
export default {
  name: 'ReleaseNotes'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/ReleaseNotes.vue